import { motion } from "framer-motion";

export default function SectionHeader({ kicker, title, copy, align = "left" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      <p className="font-official text-xs tracking-[0.3em] uppercase text-[#00A651]">{kicker}</p>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-4 text-[#F7F5F0]">
        {title}
      </h2>
      {copy && <p className="text-base sm:text-lg text-[#8A99AD] leading-relaxed mt-5">{copy}</p>}
    </motion.div>
  );
}
